<template>
  <div class="top_bar">
    <router-link to
      ><el-button class="back" @click="$router.back(-1)"
        >返回</el-button
      ></router-link
    >
    <router-link :to="'/'"
      ><el-button class="back">主页</el-button></router-link
    >
  </div>
  <div class="zhanwei2"></div>
  <div class="game">
    <div class="game_left">
      <img
        src="https://s3-ap-northeast-1.amazonaws.com/popworld-tourguide-storage2/images/game_default_cover.png?1717571493"
        alt=""
      />
    </div>
    <div class="game_center">
      <p>我的新游戏</p>
      <p>建立于2024-06-05 15:11:33</p>
      <p>导览编号23118</p>
      <p>繁体中文 不限地区─ 任何地点</p>
      <p>我建立了一个新游戏，快来玩玩看我做的游戏！</p>
    </div>
    <div class="game_right">
      <p>更新时间2024-06-08 14:39:23</p>
      <p>编辑</p>
      <p>删除</p>
    </div>
  </div>
  <div class="game">
    <div class="game_left">
      <img
        src="https://s3-ap-northeast-1.amazonaws.com/popworld-tourguide-storage2/images/game_default_cover.png?1717571493"
        alt=""
      />
    </div>
    <div class="game_center">
      <p>我的新游戏</p>
      <p>建立于2024-06-05 15:11:33</p>
      <p>导览编号23118</p>
      <p>繁体中文 不限地区─ 任何地点</p>
      <p>我建立了一个新游戏，快来玩玩看我做的游戏！</p>
    </div>
    <div class="game_right">
      <p>更新时间2024-06-08 14:39:23</p>
      <p>编辑</p>
      <p>删除</p>
    </div>
  </div>
  <div class="game">
    <div class="game_left">
      <img
        src="https://s3-ap-northeast-1.amazonaws.com/popworld-tourguide-storage2/images/game_default_cover.png?1717571493"
        alt=""
      />
    </div>
    <div class="game_center">
      <p>我的新游戏</p>
      <p>建立于2024-06-05 15:11:33</p>
      <p>导览编号23118</p>
      <p>繁体中文 不限地区─ 任何地点</p>
      <p>我建立了一个新游戏，快来玩玩看我做的游戏！</p>
    </div>
    <div class="game_right">
      <p>更新时间2024-06-08 14:39:23</p>
      <p>编辑</p>
      <p>删除</p>
    </div>
  </div>
  <div class="zhanwei3"></div>
  <div class="page">
    <el-pagination background layout="prev, pager, next" :total="1000" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "App",
  data(): any {
    return {
      title: "欢迎来到Vue 3页面模版",
      counter: 0,
      message: "",
      data: null,
      loading: false,
      error: "",
      boxRef: null,
    };
  },
  computed: {
    doubledCounter(): number {
      return this.counter * 2;
    },
  },
  watch: {
    counter(newVal: number, oldVal: number) {
      console.log(`Counter changed from ${oldVal} to ${newVal}`);
    },
    message(newVal: string, oldVal: string) {
      console.log(`Message changed from "${oldVal}" to "${newVal}"`);
    },
  },
  mounted() {},
  methods: {
    handleCommand(command: string) {
      this.$i18n.locale = command;

      localStorage.setItem("lang", command);
    },
  },
});
</script>

<style lang="less" scoped>
.top_bar {
  width: 100%;
  height: 100px;
  position: fixed;
  display: flex;
  justify-content: start;
  align-items: center;
  align-content: center;
  z-index: 9999;
  background: #fff;
  border-bottom: 2px solid rgba(176, 172, 172, 0.3);

  .back {
    margin-left: 20px;
    width: 100px;
  }
}

.game {
  width: 80%;
  height: 300px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  border-bottom: 1px solid rgba(196, 196, 196, 0.52);
  padding-bottom: 20px;
  margin-top: 20px;

  &_left {
    width: 20%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000;

    img {
      width: 100%;
    }
  }

  &_center {
    width: 60%;
    height: 100%;

    p {
      width: 100%;
      height: 15%;
      text-indent: 20px;
      line-height: 50px;

      &:nth-child(1) {
        font-size: 18px;
        font-weight: bold;
      }
      &:nth-child(3) {
        color: #2da8e0;
      }
      &:nth-child(4) {
        color: #f87d7d;
      }
      &:nth-child(5) {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  &_right {
    width: 20%;
    height: 100%;

    p {
      margin-top: 10px;
      &:nth-child(1) {
        font-size: 16px;
        font-weight: bold;
        cursor: default;
      }

      &:nth-child(2) {
        width: 100px;
        height: 40px;
        background: #006fff;
        color: #ffff;
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
          background: rgba(0, 111, 255, 0.71);
        }
      }

      &:nth-child(3) {
        width: 100px;
        height: 40px;
        background: #fa4f5c;
        color: #ffff;
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
          background: rgba(250, 79, 92, 0.71);
        }
      }
    }
  }
}
.page {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
